var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.38V126.622 c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38 C512,406.557,494.833,423.724,473.655,423.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M8.828,256h238.345c4.875,0,8.828-3.951,8.828-8.828V97.104c0-4.875-3.953-8.828-8.828-8.828H38.345 C17.167,88.277,0,105.444,0,126.622v120.552C0,252.049,3.953,256,8.828,256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M96.403,172.139c0-8.722,3.534-16.618,9.248-22.335l-26.474-7.573 c-1.537-0.439-2.638,1.469-1.49,2.58l19.811,19.155l-26.734,6.684c-1.55,0.387-1.55,2.591,0,2.979l26.734,6.684l-19.811,19.155 c-1.149,1.111-0.047,3.019,1.49,2.58l26.474-7.573C99.937,188.757,96.403,180.861,96.403,172.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M105.665,149.79c5.717-5.714,13.613-9.248,22.335-9.248s16.618,3.534,22.335,9.248l7.573-26.474 c0.439-1.537-1.469-2.638-2.58-1.49l-19.155,19.81l-6.684-26.734c-0.387-1.55-2.591-1.55-2.979,0l-6.684,26.734l-19.155-19.81 c-1.111-1.149-3.02-0.047-2.58,1.49L105.665,149.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M150.335,194.488c-5.717,5.714-13.613,9.248-22.335,9.248s-16.618-3.534-22.335-9.248l-7.573,26.475 c-0.439,1.537,1.469,2.638,2.58,1.49l19.155-19.81l6.684,26.734c0.387,1.55,2.591,1.55,2.979,0l6.684-26.734l19.155,19.81 c1.111,1.149,3.019,0.047,2.58-1.49L150.335,194.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M185.236,170.648l-26.734-6.684l19.81-19.155c1.149-1.111,0.047-3.019-1.49-2.58l-26.474,7.573 c5.714,5.718,9.248,13.613,9.248,22.335s-3.534,16.618-9.248,22.335l26.474,7.573c1.537,0.439,2.638-1.469,1.49-2.58l-19.81-19.155 l26.734-6.684C186.787,173.241,186.787,171.038,185.236,170.648z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 128,
    cy: 172.141,
    r: 25.16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.a4764d84b4e4bf5ff52e5eef97930e43.svg";
export { ForwardRef as ReactComponent };